// extracted by mini-css-extract-plugin
module.exports = {"parent":"loading_parent__wHC9N","container":"loading_container__jQAa5","dot":"loading_dot__x_rDD","swing":"loading_swing__AkR2m","swing2":"loading_swing2__M3fwS"};